"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAnchorModalListenerModule = void 0;
const effects_1 = require("redux-saga/effects");
const redux_saga_1 = require("redux-saga");
const next_app_controller_reducers_sagas_main_reducer_n_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n");
const filePath = 'sagas/modals-saga-n/anchor-modal-listener-module';
const modalDelimiter = `${process.env.NEXT_PUBLIC_MODAL_DELIMITER}`;
let addModalModule = null;
function* anchorModalListener({ end = false, history }) {
    return (0, redux_saga_1.eventChannel)((emitter) => {
        const iv = 0;
        if (!end) {
            const bhistory = modalDelimiter === '#'
                ? history.createHashHistory()
                : history.createBrowserHistory();
            bhistory.listen(({ location }) => {
                emitter(location);
            });
        }
        else {
            clearInterval(iv);
            emitter(redux_saga_1.END);
        }
        // The subscriber must return an unsubscribe function, but it will never happen
        return () => {
            if (iv !== null) {
                clearInterval(iv);
            }
        };
    });
}
function* initAnchorModalListenerModule(data) {
    try {
        //  todo: interpreta el caso base en aterrizaje
        const { end, history } = data;
        const chan = yield (0, effects_1.call)(anchorModalListener, { end, history });
        while (true) {
            const info = yield (0, effects_1.take)(chan);
            try {
                // si hay modales encoladas tengo que quitar una modal
                const modalsHistory = (state) => state.modals.modalHistory;
                const modalHistory = yield (0, effects_1.select)(modalsHistory);
                if (modalHistory && modalHistory.length > 0) {
                    if (!addModalModule) {
                        addModalModule = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('../add-modal'))));
                        addModalModule = addModalModule.default;
                    }
                    yield (0, effects_1.call)(addModalModule, {
                        id: '',
                        type: 'MODAL',
                        history,
                    });
                }
            }
            catch (error) {
                yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
                    error,
                    filePath,
                    kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.ERROR,
                    processName: 'initAnchorModalListener-operation',
                }));
            }
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            error,
            filePath,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.ERROR,
            processName: 'initAnchorModalListener-chanbind',
        }));
    }
}
exports.initAnchorModalListenerModule = initAnchorModalListenerModule;
exports.default = anchorModalListener;
//# sourceMappingURL=index.js.map